import gsap from 'gsap';
import { CustomWiggle } from 'gsap/CustomWiggle';
import { Sizes } from '../utils';

gsap.registerPlugin( CustomWiggle );

export class WiggleItem {
	constructor( selector, options = {} ) {
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			theType: options?.theType || 'uniform',
			wiggles: options?.wiggles || 10,
			duration: options.duration || 2,
			power: options?.power || 1,
			transform: options?.transform || 'move',
			interval: options?.interval || 0,
		};
		this.isEnable = false;

		this.gsapVars = {};
		this.initInterval = null;
	}

	init() {
		if ( ! this.elements?.length ) return;
		if ( this.options.devices.includes( this.sizes.device ) ) {
			if ( this.options.transform === 'rotate' ) {
				this.gsapVars.rotate = 10 * this.options.power;
			} else if ( this.options.transform === 'scale' ) {
				this.gsapVars.scale = 1.2 * this.options.power;
			} else {
				this.gsapVars.x = 10 * this.options.power;
			}
			CustomWiggle.create( 'myWiggle', {
				wiggles: this.options.wiggles,
				type: this.options.theType,
			} );
			this.gsapVars.duration = this.options.duration;
			this.gsapVars.ease = 'myWiggle';
			const tween = gsap.to( this.elements, this.gsapVars );
			if ( this.options.interval ) {
				this.initInterval = setInterval( function () {
					tween.restart();
				}, this.options.interval * 1000 );
			}
			this.isEnable = true;
		}
	}

	kill() {
		if ( this.initInterval ) clearInterval( this.initInterval );
		gsap.killTweensOf( this.elements );
		gsap.set( this.elements, { clearProps: 'all' } );
		this.gsapVars = {};
		this.initInterval = null;
		this.isEnable = false;
	}

	resize() {
		if ( this.isEnable ) {
			this.kill();
		}
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.init();
		}
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.gsapVars = null;
		this.isEnable = null;
	}
}
